import React from 'react';
// import { FormTextInput } from 'routes/auth/style';/*  */
import styled from 'styled-components';
import { H3 } from 'components/typography';
import { H2, H4 } from 'components/typography';
import Form from 'components/form';
import { WithMargin } from 'components/layout';
import { useTranslation } from 'i18n';
import { useUserApi } from 'services/user-service';
import { useHistory } from 'react-router-dom';
import { useLocalState } from 'state';
import { object, string } from 'yup';
import storage from 'services/storage';
import { toast } from 'services/toast';
import { useLocation } from 'react-router';
import { useParams } from 'react-router';

import { normalize } from 'utils/styles';
import { color, typography } from 'styles/settings';
import { FileInput } from 'routes/surface/components/node-modal-form/style';

import surfaceNodeQuery from 'graphql/surface-node/queries/upload';

import { ReactComponent as LogoIcon } from 'styles/icons/logo.svg';

// import DocumentNodeForm from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form';
// import UploadFileForm from 'routes/surface/components/node-modal-form/components/document-node-modal/components/document-node-form/components/upload-file-form';
// import ImageNodeForm from 'routes/surface/components/node-modal-form/components/image-node-modal/components/image-node-form';
// import If from 'components/if-statement';
import useSaveSurfaceDocumentNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-document-node';
import useSaveSurfaceImageNode from 'routes/surface/components/node-modal-form/hooks/use-save-surface-image-node';
import useSaveNodeInCache from 'components/canvas/hooks/use-save-node-in-cache';
import useFileToLocalUrl from 'hooks/use-file-to-local-url';
import { useUploadSurfaceNodeFile } from 'components/canvas/hooks/use-upload-surface-node-file';
// import { useTranslation } from 'i18n';
// import { withModal } from 'hoc';
import { asyncAction } from 'utils/js';
import { set } from 'lodash/fp';
// import { toast } from 'services/toast';
// import { ModalContext } from 'hoc/with-modal';

import useMutation from 'hooks/use-mutation';
import { addSurfaceNodeToSurfaceProtocolNodeMutation } from 'graphql/surface-node/mutations/surface-protocol-node/add-surface-node-to-surface-protocol-node';
import { SurfaceNodeUnion, SurfaceProtocolNode } from 'graphql/types';
import { PROTOCOL_PADDING } from 'components/canvas/components/nodes/components/protocol-node';

import {
  SurfaceDocumentNode,
  SurfaceDocumentNodeFormat,
  SurfaceImageNodeFormat,
  SurfaceNodeType,
} from 'graphql/types';
import { NodeModalInput } from 'types';

export const HeaderStyledLogoIcon = styled(LogoIcon)`
  padding: 16px;
  position: relative;
`;

export const Header = styled.div`
  position: relative;
  width: 100%;
  height: 56px;
  background-color: white;
`;

function createValidationSchema(t) {
  return function () {
    return object().shape({
      email: string().required(t('Email is required.')),
      password: string()
        .required(t('No password provided'))
        .min(5, t('Password is too short - should be 5 chars minimum.')),
    });
  };
}

export const FormTextInput = styled(Form.TextInput)`
  width: ${normalize('575px')};
  height: 60px;
  font-size: ${typography.size.md};
`;

export const Overlay = styled.div`
  background-color: ${color.brand.greenDarkWithOpacity(0.3)};
  width: 100vw;
  height: 100vh;
  overflow: none;
  position: relative;
`;

export const Container = styled.div`
  background-color: ${color.neutral.white};
  margin: 0;
  position: absolute;
  top: 53%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${normalize('24px')} ${normalize('32px')};
  max-width: 1600px;
`;

export default function SharePage() {
  const { t } = useTranslation();
  const location = useLocation();
  const { setToState } = useLocalState();
  const userApi = useUserApi();

  const [data, setData] = React.useState<any>();

  const { key } = useParams<{ key: string }>();

  const history = useHistory();

  const email = new URLSearchParams(location.search).get('email');

  async function onSubmitX({ email, password }) {
    console.log('ON SUBMIT ', email);
    /*     const response = await userApi.adminLogin(email, password);

    if (response.isSuccess) {
      const adminToken = response.getField('data.token');
      const user = response.getField('data.user');

      await setToState({ user });

      await storage.setAdminToken(adminToken);

      return history.push('/admin/sign-in-code/list');
    } */

    toast.error('Not Implemented');
  }

  //const saveNodeInCache = useSaveNodeInCache();
  const saveSurfaceDocumentNode = useSaveSurfaceDocumentNode(
    data?.surfaceId || '',
  );
  const saveSurfaceImageNode = useSaveSurfaceImageNode(data?.surfaceId || '');
  const uploadFile = useUploadSurfaceNodeFile(data?.surfaceId || '');

  function getFileFormat(file): string | undefined {
    if (file?.type.includes('pdf')) {
      return SurfaceDocumentNodeFormat.Pdf;
    }

    if (file?.type.includes('jpg')) {
      return SurfaceImageNodeFormat.Jpg;
    }

    if (file?.type.includes('jpeg')) {
      return SurfaceImageNodeFormat.Jpeg;
    }

    if (file?.type.includes('png')) {
      return SurfaceImageNodeFormat.Png;
    }
  }

  const [addSurfaceNodeToSurfaceProtocolNode] = useMutation(
    addSurfaceNodeToSurfaceProtocolNodeMutation,
  );

  //

  async function onSubmit(input, { setSubmitting }) {
    console.log(' XXXXX ', input.file);
    console.log(' XXXXX ', data.pos);

    if(input.comment == undefined){
      toast.error("Kommentar ist benötigt");
      return

    }

    if(input.file == undefined){
      toast.error("Datei ist benötigt");

        return
    }

    
    const inp = {
      format: getFileFormat(input.file),
      name: input.comment,
      position: data.position,
      surface: data?.surfaceId,
      // url: "blob:https://my.cortlex.at/688653f4-d921-4563-a992-e7440990abdd"
    };

    const isDocument =
      input?.file?.type.includes('pdf') ||
      input?.type === SurfaceNodeType.Document;

    const saveOperation = isDocument
      ? saveSurfaceDocumentNode
      : saveSurfaceImageNode;

    console.log('AAAA 1');
    const response2 = await saveOperation({ variables: { input: inp } });

    console.log('AAAA 2', response2);
    if (response2.isFailure) {
      //setSubmitting(false);
      console.error(response2.getErrorMessage());
      toast.error(response2.getErrorMessage());

      return response2;
    }

    console.log('AAAA');
    const node = response2.getField('data');

    console.log('AAAA', node);
    // Upload a file  then set correct values and submit data
    const [error] = await asyncAction(uploadFile(input.file, node.id));

    const inputProt = {
      node: node.id,
      protocolNode: data.id,
    };

    const position = {
      //@ts-ignore
      x: data?.position?.x + PROTOCOL_PADDING,
      //@ts-ignore
      y: data?.position?.y + PROTOCOL_PADDING,
    };

    const response3 = await addSurfaceNodeToSurfaceProtocolNode({
      variables: {
        input: inputProt,
        positionInput: { nodeId: data.id, position },
      },
    });

    console.log('AAAA 2', response3);
    if (response3.isFailure) {
      //setSubmitting(false);
      console.error(response3.getErrorMessage());
      toast.error(response3.getErrorMessage());

      return response2;
    }

    // if (error) {
    //   Sentry.captureException(error);
    // }

    // saveNodeInCache(set('updatedAt', new Date().toISOString(), node));
    setData("uploaded")
    return response2;
  }

  const initialValues = {
    // email: email || '',
    // password: '',
    // ...data,
    // //file,
    // name: data.name,
    // format: getFileFormat(file),
    // ...(file ? { type, url: fileUrl } : {}),
  };

  const validationSchema = createValidationSchema(t);

  const dates = {
    data2: {
      userName: 'Test User 2',
      name: 'Other Placehoder Name',
      comment:
        ' Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor ',
      accept: ['jpeg', 'pdf'],
    },
    data: {
      userName: 'Test User One',
      name: 'Placehoder Name',
      comment: ' kommentar 1 ',
      accept: ['jpeg', 'pdf'],
    },
    test: {
      userName: 'Test User One',
      name: 'Placehoder Name',
      comment: ' kommentar 1 ',
      accept: ['jpeg', 'pdf'],
    },
  };

  //const data = dates[key]

  React.useEffect(() => {
    console.log('XXX USE1');
    (async function () {
      console.log('XXX USE2');
      const data = await surfaceNodeQuery({
        id: key,
      });
      let map ={
        "6078928ce3ce4f1b802cb958f6afde1f": "BBErnd",
        // "6078928ce3ce4f1b802cb958f6afde1f": ""
        "601daa2575f44626b92b9b2dca36d6b9" : "Niki Ochsenhofer",
        "6022acdf3100467e88e6e0322e93b6c9" : "Max Ochsenhofer",
        "602fcd0c3cd94d659d9d0f0c13dde081" : "Max Ochsenhofer",
        "6078928c8b6a45e39c39f70436672dd3" : "Niki Ochsenhofer",
        "603e6110761a45a68c8b5f90e1d2aedc" : "office account"
      }

      console.warn('DATA', data.data.data);
      console.warn('DATA POS', data.data.data.position);
      if (data.data.data)
        if (!data.data.data.contains) {
          setData({
            id: data.data.data.id,
            surfaceId: data.data.data.surface.id,
            userName: map[data.data.data.ownedBy] || "-" ,
            name: data.data.data.name,
            comment: data.data.data.uploadComment,
            position: data.data.data.position,
            accept: ['jpeg', 'pdf'],
          });
        }
    })();
  }, []);

  if (data == undefined) {
    return (
      <WithMargin bottom={typography.size.xl}>
        <H2>{t(`Daten hochladen nicht mehr möglich.`)}</H2>
      </WithMargin>
    );
  }

  if (data == "uploaded") {
    return (
      <WithMargin bottom={typography.size.xl}>
        <H2>{t(`Daten erfolgreich hochgeladen.`)}</H2>
      </WithMargin>
    );
  }

  return (
    <>
      <Overlay>
        <Header>
          <HeaderStyledLogoIcon></HeaderStyledLogoIcon>
        </Header>
        <Container>
          <WithMargin bottom={typography.size.xl}>
            <H2>{t(`Teile ein Dokument mit ${data.userName}`)}</H2>
          </WithMargin>
          <WithMargin bottom={typography.size.xl}>
            <H2>{t(`Dokument: ${data.name}`)}</H2>
          </WithMargin>
          {data.comment && (
            <WithMargin bottom={typography.size.xl}>
              <H3>{t(`Anmerkung:`)}</H3>
              <br />
              <H4>{t(`${data.comment}`)}</H4>
            </WithMargin>
          )}
          <Form
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
            submitOnEnter>
            {(form) => (
              <>
                <FileInput
                  name="file"
                  //onChange={props.onFileChange}
                  label={t('Select or drag {{types}} file', {
                    replace: { types: data.accept?.join(', ') },
                  })}
                  $hasFile={form.values.file}
                  accept={data.accept}
                />
                <FormTextInput name="comment" placeholder={t('Kommentar')} />

                <WithMargin bottom={typography.size.md}>
                  <Form.SubmitButton
                    label={t('Hochladen')}
                    onClick={form.handleSubmit}
                    loading
                  />
                </WithMargin>
                {/* 
              <Form.Button
                label={t('Not registered?')}
                onClick={() => history.push('/register')}
                link
              />

              <Form.Button
                label={t('Forgot password?')}
                onClick={() => history.push('/forgot-password')}
                link
              /> */}
              </>
            )}
          </Form>
        </Container>
      </Overlay>
    </>
  );
}
